import React from 'react';

type ModalBodyLoadingSpinnerProps = {
  label?: string;
};

const ModalBodyLoadingSpinner: React.FC<ModalBodyLoadingSpinnerProps> = ({ label = '로딩 중' }) => (
  <div className="cp-modal-body-loading" role="status" aria-live="polite" aria-label={label}>
    <span className="cp-modal-body-loading-spinner" aria-hidden="true" />
  </div>
);

export default ModalBodyLoadingSpinner;
